import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { listOrder, deleteOrder } from "../../actions/orderActions";
import Axios from "../../axios/axios";
import { dateFormate } from "./utils";
import { getProductsList } from "../../actions/ProductPageAction";
import ConfirmModal from "../../components/utils/ConfirmModal";
import PDF from "./PDF";
import { PDFViewer, ReactPDF, PDFDownloadLink } from "@react-pdf/renderer";
import Header from "../../components/Layout/Header/Header";
import Footer from "../../components/Layout/Footer";
import { useNavigate } from "react-router-dom";

export default function OrderList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [allProducts, setAllProducts] = useState([]);
  const [productsLoaded, setProductsLoaded] = useState(false);
  const orderList_ = useSelector((state) => state.orderList);
  const { orders } = orderList_;

  const productList = useSelector((state) => state.productList);
  const { products } = productList;
  const [userData, setUserData] = useState("");

  console.log(userData);

  useEffect(() => {
    const UserInfo = localStorage.getItem("userInfo");
    console.log(UserInfo);
    if (UserInfo) {
      const { _id } = JSON.parse(UserInfo);
      console.log(_id); // data received(id)

      Axios.post("/api/order/list", { userId: _id })
        .then((response) => {
          setUserData(response.data);

          console.log(response, "response.data");
        })
        .catch((error) => {
          console.error(error);
        });

      dispatch(listOrder({ _id }));
    } else {
      navigate("/login");
    }
    dispatch(getProductsList(""));
  }, [dispatch]);

  console.log("dataaa", userData);

  const isRentOutInit =
    userData?.data?.length > 0 ? userData.data[0].isRentOutInit : null;

  console.log("isRentOutInit:", isRentOutInit);

  useEffect(() => {
    const fetchAllProducts = async () => {
      try {
        const response = await Axios.get("/api/products?pagination=false");

        console.log("All products response:", response.data);
        let productArray = [];
        if (Array.isArray(response.data)) {
          productArray = response.data;
        } else if (response.data.products) {
          productArray = response.data.products;
        } else if (response.data.data) {
          productArray = response.data.data;
        }

        console.log("Loaded all products:", productArray.length);
        setAllProducts(productArray);
        setProductsLoaded(true);
      } catch (error) {
        console.error("Error fetching all products:", error);
      }
    };

    fetchAllProducts();
  }, []);

  const deleteHandler = (id) => {
    setSelectedOrderId(id);
    setIsModalOpen(true);
  };

  console.log(products, "products");

  const getDelivered = (order) => {
    let result = order?.orderItems?.some((data) => data.isDelivered === false);

    return result;
  };

  const getReturn = (order) => {
    let result = order?.orderItems?.some((data) => data.isReturn === false);

    return result;
  };

  console.log(orders);

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "warning"; // Bootstrap yellow/orange
      case "processing":
        return "info"; // Bootstrap light blue
      case "approved":
        return "success"; // Bootstrap green
      case "cancelled":
        return "danger"; // Bootstrap red
      default:
        return "secondary"; // grey
    }
  };

  return (
    <body class="cart-page cart-style1-page">
      <div class="page-wrapper">
        <Header />
        <div id="page-content">
          {" "}
          <div class="page-header text-center">
            <div class="container">
              <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 d-flex justify-content-between align-items-center">
                  <div class="page-title">
                    <h1>My Orders</h1>
                  </div>
                  <div class="breadcrumbs">
                    Home
                    <span class="main-title">
                      <i class="icon anm anm-angle-right-l"></i>My Orders
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
          <div class="container">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 main-col">
                <div class="row">
                  <div class="col-lg-12 grid-margin stretch-card">
                    <div class="card">
                      {userData?.data?.length > 0 ? (
                        userData?.data.map((order) => (
                          <div class="card-body">
                            <div className="card-body">
                              <div className="d-flex">
                                <button
                                  className={`btn btn-sm ms-auto btn-${getStatusColor(
                                    order.status,
                                  )}`}
                                  disabled
                                >
                                  {order.status.charAt(0).toUpperCase() +
                                    order.status.slice(1)}
                                </button>
                              </div>
                            </div>

                            <div class="table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th>Date</th>
                                    <th>Order Id</th>
                                    <th>Customer Name</th>
                                    <th>Delivered</th>
                                    <th>Return</th>
                                    <th>Amount</th>
                                    <th>Special Price</th>
                                    <th> </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{dateFormate(order?.createdAt)}</td>
                                    <td>
                                      <Link to={`/order/${order._id}`}>
                                        ADC_{order?.orderId}
                                      </Link>
                                    </td>
                                    <td>
                                      <b>{order?.user?.name}</b> <br />{" "}
                                      <div className="mt-2">
                                        {order?.user?.phone1}
                                      </div>
                                    </td>

                                    <td>
                                      {getDelivered(order) === true
                                        ? "No"
                                        : "Yes"}
                                    </td>
                                    <td>
                                      {" "}
                                      {getReturn(order) === false
                                        ? "Yes"
                                        : "No"}
                                    </td>
                                    <td>{order?.orderAmount}</td>
                                    <td>
                                      {order?.specialPrice
                                        ? order.specialPrice
                                        : "N/A"}
                                    </td>
                                    <td>
                                      <div class="d-flex flex-row">
                                        <div class="p-2"> </div>{" "}
                                        <div class="p-2">
                                          {" "}
                                          <PDFDownloadLink
                                            document={
                                              <PDF
                                                products={allProducts}
                                                customerName={order?.user?.name}
                                                customerNumber={
                                                  order?.user?.phone
                                                }
                                                address={order?.user?.address1}
                                                invoiceId={order?.orderId}
                                                orderDate={order.createdAt}
                                                advance={order?.totalReceive}
                                                amount={order?.orderAmount}
                                                items={order?.orderItems}
                                                discount={order?.discount}
                                                specialPrice={
                                                  order?.specialPrice
                                                }
                                                qrCode={order?.qrCode}
                                              />
                                            }
                                            fileName="order.pdf"
                                          >
                                            {({ blob, url, loading, error }) =>
                                              loading ? (
                                                "Loading document..."
                                              ) : (
                                                <button
                                                  type="button"
                                                  class="btn btn-outline-primary btn-sm"
                                                >
                                                  print
                                                </button>
                                              )
                                            }
                                          </PDFDownloadLink>
                                        </div>
                                        {/* delete ///////////////////////////////// */}
                                        {!isRentOutInit && (
                                          <div class="p-2">
                                            <button
                                              type="button"
                                              className={`btn btn-sm ${
                                                order.status === "approved" ||
                                                order.status === "cancelled"
                                                  ? "btn-secondary"
                                                  : "btn-outline-danger"
                                              }`}
                                              disabled={
                                                order.status === "approved" ||
                                                order.status === "cancelled"
                                              }
                                              onClick={() =>
                                                deleteHandler(order?._id)
                                              }
                                            >
                                              cancel
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6}>No Order found on this number</td>
                        </tr>
                      )}
                    </div>
                  </div>
                  <div
                    class="modal fade"
                    id="exampleModalPrint"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                    backdrop={true}
                    data-backdrop="static"
                  >
                    {" "}
                    <form class="forms-sample">
                      <div class="modal-dialog" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel"></h5>
                            <button
                              type="button"
                              class="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>

                          <div class="modal-body" id="divToPrint"></div>

                          <div class="modal-footer">
                            <a href="/orders">
                              <button type="button" class="btn btn-secondary">
                                Close
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
        <ConfirmModal
          isOpen={isModalOpen}
          message="Are you sure you want to cancel this order?"
          onConfirm={async () => {
            if (selectedOrderId) {
              await dispatch(deleteOrder(selectedOrderId));

              // ✅ REFETCH ORDERS IMMEDIATELY
              const UserInfo = localStorage.getItem("userInfo");
              const { _id } = JSON.parse(UserInfo);

              const response = await Axios.post("/api/order/list", {
                userId: _id,
              });
              setUserData(response.data);
            }

            setIsModalOpen(false);
            setSelectedOrderId(null);
          }}
          onCancel={() => {
            setIsModalOpen(false);
            setSelectedOrderId(null);
          }}
        />
      </div>
    </body>
  );
}
